import {mainRootState, rootStore} from '@/store/types'
import {Module} from 'vuex'
import {mutations} from './mutations'
import {getters} from './getters'

const state: mainRootState = {
    registration: false,
    registrationModal: false,
    appointments: [],
    sidebarVisible: false,
    transition: 'false',
    historyCounter: 0,
    backwards: false
}

export const rootState: Module<mainRootState, rootStore> = {
    state,
    mutations,
    getters,
    namespaced: true
}

